
export type TweetFeedResponseTweetsItemMediaItemDimensions = {
  height?: number;
  width?: number;
};
